<template>
  <r-panel :disabled="disabled" :title="title" :button_add="true" @click_add="click_add">
    <r-currency-correction-table ref="table" :items.sync="values" :title="title" :toolbar="false"/>
  </r-panel>
</template>

<script>
import VueTypes from "vue-types";
import {CurrencyCorrection} from "@/modules/redactor/models/currency/CurrencyCorrection";

import RPanel from "@/modules/redactor/views/utils/r-panel.vue";
import RCurrencyCorrectionTable from "@/modules/redactor/views/currency/r-currency-correction-table.vue";


export default {
  name: "r-currency-correction-panel",
  components: {RPanel, RCurrencyCorrectionTable},
  props: {
    disabled: VueTypes.bool.def(false),
    title: VueTypes.string.def("Currency Correction"),
    items: VueTypes.arrayOf(CurrencyCorrection),
  },
  computed: {
    values() {
      if (this.items) {
        return this.items;
      } else {
        let values = [];
        this.$emit("update:items", values);
        return values;
      }
    }
  },
  methods: {
    click_add() {
      this.$refs["table"].row_create();
    }
  }
}

</script>
